<div class="title">Новости лиги</div>

<div class="news-list">
  <div class="news-item" *ngFor="let item of news">
    <div class="headline">
      <div class="date">
        {{ item.datetime | mtgDate }}, {{ item.datetime | date: 'HH:mm' }}
      </div>
      <mtg-share variant="icon" [url]="getNewsAbsoluteRoute(item.id)"></mtg-share>
    </div>
    <div class="picture" *ngIf="item.picture.path">
      <a [routerLink]="getNewsRoute(item.id)">
        <img [src]="item.picture.path" [alt]="item.title" [title]="item.title">
      </a>
    </div>
    <div class="title">
      <a [routerLink]="getNewsRoute(item.id)">{{ item.title }}</a>
    </div>
    <div class="text" [innerHTML]="item.previewText | safe: 'html'"></div>
    <a [routerLink]="getNewsRoute(item.id)" class="detail-link">Читать полностью</a>
  </div>
</div>

<div class="load-more" *ngIf="nextPageVisible">
  <mtg-button
    (click)="loadNextPage()"
  >Загрузить еще</mtg-button>
</div>
